import * as coreEntities from 'core/store/index';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

function useSystemSettings() {
  const settings = useSelector((state) => coreEntities.systemSettings.selectors.getSystemSettings(state));
  const client = useSelector((state) => coreEntities.organization.selectors.getClient(state));

  const [loading, setLoading] = useState(true);
  const [enableAdvancedProgramming, setEnableAdvancedProgramming] = useState(undefined);
  const [enableEvaluationModel, setEnableEvaluationModel] = useState(undefined);
  const [enableProgramLookAdvanced, setEnableProgramLookAdvanced] = useState(undefined);
  const [enableNutrient, setEnableNutrient] = useState(undefined);
  const [enableNutrientStandalone, setEnableNutrientStandalone] = useState(undefined);
  const [nutrientLicence, setNutrientLicence] = useState(undefined);
  const [enableLibrary, setEnableLibrary] = useState(undefined);
  const [enableLessonItemComments, setEnableLessonItemComments] = useState(undefined);
  const [enableClassroomResources, setEnableClassroomResources] = useState(undefined);
  const [enableThirdPartyIntegrations, setEnableThirdPartyIntegrations] = useState(undefined);
  const [enableTeacherConfigCourse, setEnableTeacherConfigCourse] = useState(undefined);

  useEffect(() => {
    if (settings && client) {
      setEnableAdvancedProgramming(settings?.enable_advanced_programming === 1);
      setEnableEvaluationModel(settings?.enable_evaluation_model === 1);
      setEnableProgramLookAdvanced(settings?.enable_program_look_advanced === 1);
      setEnableNutrient(settings?.enable_nutrient === 1);
      setEnableNutrientStandalone(settings?.enable_nutrient_standalone === 1);
      setNutrientLicence(settings?.nutrient_licence || '');
      setEnableLibrary(settings?.enable_library === 1);
      setEnableLessonItemComments(settings?.show_item_comments === 1);
      setEnableClassroomResources(settings?.show_program_resources === 1);
      setEnableThirdPartyIntegrations(settings?.third_party_integrations === 1);
      setEnableTeacherConfigCourse(settings?.enable_teacher_config_course === 1);
      setLoading(false);
    }
  }, [settings, client]);

  return {
    enableAdvancedProgramming,
    enableEvaluationModel,
    enableNutrient,
    enableNutrientStandalone,
    nutrientLicence,
    enableProgramLookAdvanced,
    enableLessonItemComments,
    enableLibrary,
    enableClassroomResources,
    enableThirdPartyIntegrations,
    enableTeacherConfigCourse,
    loadingSettings: loading,
  };
}

export default useSystemSettings;
